import React from 'react';
import { Row, Col } from 'antd';
import { BInput } from 'common/components';

const ShopByFamilySection = ({ statusSwitch }) => {
  return (
    <div>
      <Row>
        <Col span={24}>
          <BInput
            disabled={statusSwitch}
            className="form-add-user-input"
            name="period"
            max={100}
            placeholder="Escribe un periodo"
            label="Periodo:"
          />
        </Col>
      </Row>
    </div>
  );
};

export default ShopByFamilySection;
